import { useTranslation } from "react-i18next";
import { Tabs, Group, Text, Badge } from "@mantine/core";
import TAB_ITEMS from "../constants/tab.constant";
import { useGetNotificationStickyQuery } from "@/services/notificationAPI";
import { NsType } from "@/dto/notifications/response/enum";

interface CustomTabsProps {
  tabs?: string;
  onTabChange?: (value: string) => void;
}

const CustomTabs = ({ tabs = "All", onTabChange }: CustomTabsProps) => {
  const { t } = useTranslation();

  // notifyUnview from getNotificationSticky is the total unread count.
  // There is no per-tab breakdown (getNsUnView was removed).
  // Show the total on the "personal" tab; leave the news tab without a count.
  const { data } = useGetNotificationStickyQuery({
    nsType: NsType.Private,
    pageNo: 1,
    pageSize: 20,
  });
  const totalUnread = data?.body?.notifyUnview;

  const commonTabStyles = {
    color: "#5E656B",
    display: "flex",
    alignItems: "center",
    width: "180px",
    height: "56px",
    padding: 0,
    fontWeight: 400,
    gap: "8px",
    backgroundColor: "transparent",
    borderBottom: "2px solid transparent",
    transition: "all 0.3s ease-in-out",
    "&[data-active]": {
      color: "#2A81D0",
      borderBottom: "2px solid #2A81D0",
      fontWeight: 700,
      backgroundColor: "transparent",
    },
    "&:hover": {
      color: "inherit",
      borderBottom: "2px solid transparent",
      backgroundColor: "transparent",
    },
    "&:focus": {
      outline: "none",
      boxShadow: "none",
    },
    "&[data-active]:hover, &[data-active]:focus": {
      color: "#2A81D0",
      borderBottom: "2px solid #2A81D0",
      fontWeight: 700,
      backgroundColor: "transparent",
    },
  };

  return (
    <Tabs value={tabs} onTabChange={onTabChange}>
      <Tabs.List
        sx={{
          display: "flex",
          justifyContent: "center",
          border: "none",
        }}
      >
        <Tabs.Tab value={TAB_ITEMS[0].value} sx={commonTabStyles}>
          <Group sx={{ gap: "8px", display: "flex" }}>
            <Text size={14}>{t(TAB_ITEMS[0].label)}</Text>
            {totalUnread !== undefined && totalUnread > 0 && (
              <Badge radius={36} bg="#E6492D">
                <Text size={10} weight={700} color="#fff">
                  {totalUnread}
                </Text>
              </Badge>
            )}
          </Group>
        </Tabs.Tab>

        <Tabs.Tab value={TAB_ITEMS[1].value} sx={commonTabStyles}>
          <Group sx={{ gap: "8px", display: "flex" }}>
            <Text size={14}>{t(TAB_ITEMS[1].label)}</Text>
          </Group>
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
};

export default CustomTabs;
